import { render } from "./ServiceSection.vue?vue&type=template&id=57c8fc9e&scoped=true"
import script from "./ServiceSection.vue?vue&type=script&lang=js"
export * from "./ServiceSection.vue?vue&type=script&lang=js"

import "./ServiceSection.vue?vue&type=style&index=0&id=57c8fc9e&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c8fc9e"]])

export default __exports__